import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import MeditationUserDetail from './MeditationUserDetail';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyMeditationUserDetail } from './companyMeditationApi';

/**
 * Company Meditation Sounds → one employee's/member's meditation profile.
 * Reuses the shared detail page with the company-scoped fetcher (the backend
 * 404s any user who doesn't belong to this company).
 */
const CMeditationUserDetail = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>User Meditation Profile | Shoorah</title>
      </Helmet>
      <MeditationUserDetail
        fetcher={fetchCompanyMeditationUserDetail}
        backPath={`/${slug}/meditation/users`}
        backLabel={isB2BFansMode ? 'Back to Members' : 'Back to Employees'}
      />
    </div>
  );
};

export default CMeditationUserDetail;
